import icon1 from '../../../Assets/Icons/menu1.svg';
import icon2 from '../../../Assets/Icons/menu2.svg';
import icon3 from '../../../Assets/Icons/menu3.svg';
import icon4 from '../../../Assets/Icons/menu4.svg';
import icon5 from '../../../Assets/Icons/menu5.svg';
import icon6 from '../../../Assets/Icons/profile-user.svg';
import icon7 from '../../../Assets/Icons/menu7.svg';
import icon8 from '../../../Assets/Icons/web-site.svg';

import icon21 from '../../../Assets/Icons/menu22.svg';
import icon22 from '../../../Assets/Icons/menu21.svg';
import icon23 from '../../../Assets/Icons/menu23.svg';
import icon24 from '../../../Assets/Icons/menu24.svg';
import icon25 from '../../../Assets/Icons/menu25.svg';
import icon26 from '../../../Assets/Icons/menu26.svg';
import icon27 from '../../../Assets/Icons/menu27.svg';
import icon28 from '../../../Assets/Icons/menu28.svg';

import icon31 from '../../../Assets/Icons/menu31.svg';
import icon32 from '../../../Assets/Icons/menu32.svg';
import icon33 from '../../../Assets/Icons/menu33.svg';
import icon34 from '../../../Assets/Icons/menu34.svg';
import icon35 from '../../../Assets/Icons/menu35.svg';
import icon36 from '../../../Assets/Icons/menu36.svg';



import li1 from '../../../Assets/Icons/enterprise.svg';
import li2 from '../../../Assets/Icons/privacy.svg';
import li3 from '../../../Assets/Icons/careers.svg';
import li4 from '../../../Assets/Icons/developer.svg';
import li5 from '../../../Assets/Icons/mobile.svg';
import li6 from '../../../Assets/Icons/terms.svg';


export const listitems=[
    {
        item:li1,
        title:"Enterprise"
    },
    {
        item:li2,
        title:"Privacy"
    },
    {
        item:li3,
        title:"Careers"
    },
    {
        item:li4,
        title:"Developer API"
    },
    {
        item:li5,
        title:"Mobile Apps"
    },
    {
        item:li6,
        title:"Terms of Service"
    }
]
export const menu1 = [
    {
        icon:icon1,
        title:"Collaboration",
        desc:"Design feedback and iterations",
        to:"/collaboration"
    },
    {
        icon:icon2,
        title:"Wireframing",
        desc:"Create low-fidelity wireframes with simple drag&drop.",
        to:"/wireframe"
    },
    {
        icon:icon3,
        title:"Prototyping",
        desc:"Interactive mockups, without coding.",
        to:"/prototyping"
    },
    {
        icon:icon4,
        title:"Usability Testing",
        desc:"Analyze how users interact with your interfaces."
    }
]
export const menu2 = [
    {
        icon:icon5,
        title:"Why HostDesign",
        desc:"We're on a mission to help the world bring ideas to life.",
        to:"/why"
    },
    {
        icon:icon6,
        title:"Customers Story",
        desc:"The world's most innovative companies use HostDesign,",
        to:"/customer-stories"
    },
    {
        icon:icon7,
        title:"Help Center",
        desc:"You well get super fast solution in the world.",
        to:"/help-center"
    },
    {
        icon:icon8,
        title:"Blog",
        desc:"The best design articles every day.",
        to:"/blog"
        
    }
]


export const menu3 = [
    {
        icon:icon21,
        title:"About Us",
        desc:"Bringing the world's ideas to life"
    },
    {
        icon:icon22,
        title:"Status",
        desc:"All Systems Operational",
        to:"/status"
    },
    {
        icon:icon23,
        title:"Security",
        desc:"Enterprise Security Features",
        to:"/security"
    },
    {
        icon:icon24,
        title:"Resources",
        desc:"A library of educational gems that’ll get you up to speed"
    }
]
export const menu4 = [
    {
        icon:icon25,
        title:"Jobs",
        desc:"We're on a mission to help the world bring ideas to life.",
        to:"/jobs"
    },
    {
        icon:icon26,
        title:"eBooks",
        desc:"Download the free eBook.",
        to:"/ebooks"
    },
    {
        icon:icon27,
        title:"Webinars",
        desc:"Catch up on our latest webinars."
    },
    {
        icon:icon28,
        title:"Product Updates",
        desc:"Keep up with all our product launches, small ships and news"
    }
]

export const menu5 = [
    {
        icon:icon31,
        title:"Desktop",
        desc:"Download the Desktop App",
        to:"/desktop"
    },
    {
        icon:icon32,
        title:"Android Phone",
        desc:"Download the Android Phone",
        to:"/android-phone"
    },
    {
        icon:icon33,
        title:"Android Tablet",
        desc:"Download the Android Tablet",
        to:"/android-pad"
    },

   
]
export const menu6 = [
    {
        icon:icon34,
        title:"iMac",
        desc:"Download the iMac App",
        to:"/imac-app"
    },
    {
        icon:icon35,
        title:"iPhone",
        desc:"Download the iPhone App",
        to:"/mobile-app"
    },
    {
        icon:icon36,
        title:"iPad",
        desc:"Download the iPad App",
        to:"/ipad-app"
    },
   
]
